import React from 'react';
import { Link } from 'react-router-dom';
import { Permissions } from '@upstart/harmony/lib/constants';
import withUserPermission from './userPermission';

function EmployeeAddButton() {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/employees/user/' }}
    >
      Add New
    </Link>
  );
}

export default withUserPermission(Permissions.CREATE)(EmployeeAddButton);
